module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-chapel-2a401928bbac5bbd2cde6dc872a60b63.jpg";